// src/components/Services.js
import React from 'react';
import '../css/Services.css';
// If you want real icons, e.g. from react-icons:
// import { FaCode, FaDatabase, FaLightbulb } from 'react-icons/fa';

const Services = () => {
  return (
    <section className="services" id="services">
      <h2 className="services-title">Services</h2>
      <p className="services-subtitle">What I do best to help you succeed</p>

      <div className="services-grid">
        
        {/* 1) Full-Stack Development */}
        <div className="service-item">
          {/* Example icon or emoji */}
          <div className="service-icon">⚙️</div>
          <h3>Full-Stack Development</h3>
          <p>
            From front-end interfaces to back-end logic, I build responsive, 
            scalable, and maintainable applications that drive real value.
          </p>
          <ul className="service-details">
            <li>React, Node.js, Flask, Express</li>
            <li>Responsive UI/UX design</li>
            <li>Performance optimization</li>
          </ul>
        </div>

        {/* 2) Backend Architecture */}
        <div className="service-item">
          <div className="service-icon">🔒</div>
          <h3>Backend Architecture</h3>
          <p>
            Craft secure RESTful APIs and real-time backends, leveraging JWT authentication 
            and robust databases to power your mission-critical apps.
          </p>
          <ul className="service-details">
            <li>JWT & OAuth security</li>
            <li>MongoDB, SQL, or Firebase</li>
            <li>Scalable microservices & WebSockets</li>
          </ul>
        </div>

        {/* 3) Consulting & Solutions */}
        <div className="service-item">
          <div className="service-icon">💡</div>
          <h3>Consulting & Custom Solutions</h3>
          <p>
            Partner with me for bespoke solutions, detailed code reviews, 
            and performance optimizations that take your products to the next level.
          </p>
          <ul className="service-details">
            <li>Architecture & design reviews</li>
            <li>Performance audits</li>
            <li>Custom feature implementation</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Services;
